import { Stack } from '@mui/material'

import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import { SiteRevenueExportButton } from '@/features/site/components/revenue/SiteRevenueExportButton'
import { SiteSelector } from '@/features/site/components/SiteSelector'
import type { UseRevenueFiltersResult } from '@/features/site/hooks/useRevenueFilters'
import type { InsightRevenueDateTimeRange } from '@/features/site/types/revenue'

import SiteRevenueMarketProgramFilter from './SiteRevenueMarketProgramFilter'
import { SiteRevenuePeriodFilter } from './SiteRevenuePeriodFilter'

type SiteDetailsRevenueAppBarProps = {
  siteUuid: string
  timezone: string
  revenueFilters: UseRevenueFiltersResult
  availableMarketPrograms: string[]
  limitDateTimeRange: InsightRevenueDateTimeRange
  onExport: () => void
}

export function SiteDetailsRevenueAppBar({
  siteUuid,
  timezone,
  revenueFilters,
  availableMarketPrograms,
  limitDateTimeRange,
  onExport,
}: Readonly<SiteDetailsRevenueAppBarProps>) {
  const [state, dispatch] = revenueFilters

  const { permissions } = usePermissions()

  function handleMarketProgramsChange(marketPrograms: string[]) {
    dispatch({ type: 'setMarketPrograms', payload: marketPrograms })
  }

  function handleTimeRangeChange(timeRange: InsightRevenueDateTimeRange) {
    dispatch({ type: 'setTimeRange', payload: timeRange })
  }

  return (
    <Stack alignItems="center" direction="row" justifyContent="space-between" spacing={1} sx={{ width: '100%' }}>
      <Stack direction="row" flex={1} spacing={1}>
        {permissions.has('siteDetails') && <SiteSelector siteUuid={siteUuid} />}

        <SiteRevenueMarketProgramFilter
          availableMarketPrograms={availableMarketPrograms}
          marketPrograms={state.marketPrograms}
          onChange={handleMarketProgramsChange}
        />

        <SiteRevenuePeriodFilter
          defaultPeriod="year"
          limitDateTimeRange={limitDateTimeRange}
          timeRange={state.timeRange}
          timezone={timezone}
          onChange={handleTimeRangeChange}
        />
      </Stack>

      <SiteRevenueExportButton onExport={onExport} />
    </Stack>
  )
}
